import React from "react";
import { useTheme } from "@/context/ThemeContext";
import { Sun, Moon } from "lucide-react";
import { NAV } from "@/constants/testIds";

/**
 * Compact theme toggle used on pre-authentication pages (landing, login,
 * register, accept-invite). Renders fixed top-right by default but accepts a
 * `className` override for in-flow placement.
 */
export default function ThemeToggle({ floating = true, className = "" }) {
  const { theme, toggle } = useTheme();
  const base =
    "inline-flex items-center gap-2 px-3 py-2 rounded-md border border-border bg-background/80 backdrop-blur text-foreground hover:bg-secondary transition text-xs";
  const float = floating ? "fixed top-4 right-4 z-50" : "";
  return (
    <button
      data-testid={NAV.themeToggle}
      onClick={toggle}
      aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
      className={`${base} ${float} ${className}`}
    >
      {theme === "dark" ? <Sun className="w-3.5 h-3.5" /> : <Moon className="w-3.5 h-3.5" />}
      <span className="label-mono">{theme === "dark" ? "Light" : "Dark"}</span>
    </button>
  );
}
